/**
* Planetarium Banner JS
* -----------------------------------------------------------------------------
*
* All the JS for the Planetarium Banner component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'planetarium-banner',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      gsap.registerPlugin( ScrollTrigger );

      $( '.planetarium-banner' ).each( function( key, val ) {
        const planets = $( this ).find( '.planets' )[0];
        const content = $( this ).find( '.content-area' )[0];
        const height = $( this ).outerHeight();

        if ( !window.matchMedia( '(prefers-reduced-motion)' ).matches ) {
          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: '.planets-area',
              start: 'top top',
              end: 'bottom top',
              scrub: true,
              // markers: true,
            },
          } );
          tl.to( planets, {scale: '2.5', y: '50%', opacity: '0', ease: 'linear'}, 0 );
          tl.to( content, {y: '250px', opacity: '0', ease: 'linear'}, 0 );
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'planetarium-banner', COMPONENT );
} )( app );
